var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReset = function SvgReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5163 9.08702L16.6669 12.237L19.8169 9.08702L18.9331 8.20323L17.2838 9.85248C17.2113 6.44231 14.813 3.52535 11.4812 2.79501C8.14937 2.06467 4.75079 3.71095 3.25848 6.77811C1.76616 9.84528 2.56834 13.5354 5.1993 15.7062C7.83027 17.8771 11.6056 17.9639 14.3335 15.9162L13.5828 14.9165C12.5209 15.7177 11.2259 16.1492 9.89571 16.1451C6.52182 16.1487 3.77586 13.4317 3.74359 10.058C3.71132 6.68424 6.4048 3.91525 9.77814 3.85425C13.1515 3.79325 15.9433 6.46305 16.033 9.83575L14.4001 8.20321L13.5163 9.08702Z",
    fill: "#0271EB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset.8f5f9bd9.svg";
export { ForwardRef as ReactComponent };